<template>
  <CoreCard
    class="p-4 h-full max-h-full"
    body-cls="h-full w-full flex flex-col"
  >
    <template #body>
      <div class="flex">
        <CoreText value="By Brand" />
        <ChartMaximizer v-if="showMaximize">
          <ChartCompanyRevenue
            :show-maximize="false"
            :data="data"
            :chart-options="chartOptions"
          />
        </ChartMaximizer>
      </div>
      <VueApexCharts
        class="default-chart-pie"
        height="100%"
        :options="chartOptions"
        :series="data"
      />
    </template>
  </CoreCard>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";
import { CoreCard, CoreText } from "@purepm/core-ui";
import ChartMaximizer from "ui/components/ChartMaximizer.vue";

export default {
  name: "ChartCompanyRevenue",
  components: {
    ChartMaximizer,
    VueApexCharts,
    CoreCard,
    CoreText,
  },
  props: {
    showMaximize: {
      type: Boolean,
      default: true,
    },
    chartOptions: {
      type: Object,
      required: true,
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
